import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme, displayState }) => css`
    cursor: not-allowed;
  `}
`;

export default Wrapper(template);
